import { useWeeklyObjectivesStore } from "@/modules/planner/stores/use-weekly-objectives-store"
import { api } from "@/services/api"
import { formatDuration } from "@/shared/utils/date-fn"
import { useQuery } from "@tanstack/react-query"
import { intervalToDuration } from "date-fns"
import { useMemo } from "react"

export function useGetRealHoursOfStudy() {
  const { currentWeekNumber } = useWeeklyObjectivesStore()

  const query = useQuery({
    queryKey: ["get-real-hours-of-study"],
    queryFn: () => api.cronos.weeklyObjectives.getRealHoursOfStudy(),
    select: (data) => data.data.description,
  })

  const realHoursOfStudy =
    query.data?.weeks
      .find((week) => week.weekNumber === currentWeekNumber)
      ?.courses.reduce((acc, course) => acc + course.totalRealDuration, 0) ?? 0

  const previousRealHoursOfStudy =
    query.data?.weeks
      .find((week) => week.weekNumber === currentWeekNumber - 1)
      ?.courses.reduce((acc, course) => acc + course.totalRealDuration, 0) ?? 0

  const percentage = useMemo(() => {
    if (realHoursOfStudy === 0 && previousRealHoursOfStudy === 0) return 0
    if (previousRealHoursOfStudy === 0) return 100
    return ((realHoursOfStudy - previousRealHoursOfStudy) / previousRealHoursOfStudy) * 100
  }, [realHoursOfStudy, previousRealHoursOfStudy])

  const formattedDuration = useMemo(() => {
    const duration = intervalToDuration({ start: 0, end: realHoursOfStudy })
    const formatted = formatDuration(duration).min({
      hours: true,
      minutes: true,
      seconds: false,
    })

    if (!formatted) return "0 h"
    return formatted
  }, [realHoursOfStudy])

  return { formattedDuration, percentage, isPending: query.isPending }
}
